//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Search',
  props: {
    propsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    searchPadding: function searchPadding() {
      if (!this.propsData.searchPadding) {
        return '';
      }
      return "\n      ".concat(this.propsData.searchPadding.pt || 0, "px \n      ").concat(this.propsData.searchPadding.pr || 0, "px \n      ").concat(this.propsData.searchPadding.pb || 0, "px \n      ").concat(this.propsData.searchPadding.pl || 0, "px");
    }
  }
};